const LOCAL_STORAGE_PREFIX = 'PfxTutorialsDisabled.'

export default (name) => {
  return {
    data() {
      return {
        openTutorial: 1,
        tooltipsDisabled: false
      }
    },
    mounted() {
      this.$store.commit('setCurrentTutorialPageName', name)
      this.tooltipsDisabled = this.getTutorialState()
      console.log('tutorial state [%s] [%s]', name, this.tooltipsDisabled)
      this.$events.on('toggleTutorial.' + name, () => this.toggleTutorial())
      this.$events.on('scrollToTop.' + name, () => this.scrollToTop())
      this.$events.on('gotonext.' + name, () => this.nextTutorial())
      this.$events.on('gotoprevious.' + name, () => this.previousTutorial())
      this.$events.emit('updateTutorial.' + name, this.openTutorial, this.tooltipsDisabled)
    },
    beforeDestroy() {
      this.$store.commit('setCurrentTutorialPageName', null)
    },
    methods: {
      scrollToTop() {
        this.toggleTutorial()
        document.documentElement.scrollTop = 0
      },
      saveTutorialState() {
        const key = LOCAL_STORAGE_PREFIX + name
        const value = this.tooltipsDisabled ? 'true' : 'false'
        localStorage.setItem(key, value)
      },
      getTutorialState() {
        const key = LOCAL_STORAGE_PREFIX + name
        const value = localStorage.getItem(key)
        return value === 'true'
      },
      offset(el) {
        const rect = el ? el.getBoundingClientRect() : { top: 0, left: 0 }
        const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop
        return {
          top: rect.top + scrollTop,
          left: rect.left + scrollLeft
        }
      },
      nextTutorial() {
        this.openTutorial++
        this.$events.emit('updateTutorial.' + name, this.openTutorial, false)
        const el = document.getElementsByClassName('tutorial' + this.openTutorial)[0]
        if (el) window.scroll(0, this.offset(el).top - window.innerHeight / 2)
      },
      previousTutorial() {
        this.openTutorial--
        this.$events.emit('updateTutorial.' + name, this.openTutorial, false)
        const el = document.getElementsByClassName('tutorial' + this.openTutorial)[0]
        if (el) window.scroll(0, this.offset(el).top - window.innerHeight / 2)
      },
      toggleTutorial() {
        this.openTutorial = 1
        this.tooltipsDisabled = !this.tooltipsDisabled
        this.$events.emit('updateTutorial.' + name, this.openTutorial, this.tooltipsDisabled)
        this.saveTutorialState()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/tutorialMixin.js